import React from 'react';
import PageHeader from '../components/PageHeader';
import { MapPin, Users, Award, Phone } from 'lucide-react';
const About = () => {
  const stats = [{
    icon: Users,
    label: 'Happy Customers',
    value: '10,000+'
  }, {
    icon: MapPin,
    label: 'Destinations',
    value: '50+'
  }, {
    icon: Award,
    label: 'Years Experience',
    value: '15+'
  }, {
    icon: Phone,
    label: '24/7 Support',
    value: 'Always'
  }];
  const values = [{
    title: 'Islamic Values',
    description: 'We ensure all our tours and services align with Islamic principles and values.'
  }, {
    title: 'Customer First',
    description: 'Your comfort and satisfaction are our top priorities throughout your journey.'
  }, {
    title: 'Expert Guidance',
    description: 'Our experienced guides provide knowledgeable and spiritual leadership.'
  }, {
    title: 'Quality Service',
    description: 'We maintain high standards in all aspects of our travel services.'
  }];
  return <div className="w-full" data-id="element-565">
      <PageHeader title="About Kembara Ustaz" subtitle="Your Trusted Travel Companion Since 2008" backgroundImage="https://images.unsplash.com/photo-1565689157206-0fddef7589a2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80" data-id="element-566" />
      {/* Vision & Mission */}
      <section className="py-16 bg-white" data-id="element-567">
        <div className="container mx-auto px-4 md:px-8" data-id="element-568">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-569">
            <div data-id="element-570">
              <h2 className="text-3xl font-bold text-navy-900 mb-6" data-id="element-571">
                Our Vision
              </h2>
              <p className="text-navy-700 text-lg mb-8" data-id="element-572">
                To be the leading Islamic travel agency, providing meaningful
                journeys that combine spiritual fulfillment with exceptional
                travel experiences.
              </p>
              <h2 className="text-3xl font-bold text-navy-900 mb-6" data-id="element-573">
                Our Mission
              </h2>
              <p className="text-navy-700 text-lg" data-id="element-574">
                We are committed to delivering high-quality, Islamic-compliant
                travel services that enrich our customers' lives while
                maintaining the highest standards of professionalism and
                customer care.
              </p>
            </div>
            <div className="relative" data-id="element-575">
              <img src="https://images.unsplash.com/photo-1563911302283-d2bc129e7570?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="Kembara Ustaz Office" className="rounded-lg shadow-lg" data-id="element-576" />
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gold-500 rounded-lg -z-10" data-id="element-577"></div>
            </div>
          </div>
        </div>
      </section>
      {/* Stats Section */}
      <section className="py-16 bg-navy-900 text-white" data-id="element-578">
        <div className="container mx-auto px-4 md:px-8" data-id="element-579">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-580">
            {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-581">
                <stat.icon size={40} className="mx-auto mb-4 text-gold-500" data-id="element-582" />
                <div className="text-3xl font-bold mb-2" data-id="element-583">{stat.value}</div>
                <div className="text-gray-300" data-id="element-584">{stat.label}</div>
              </div>)}
          </div>
        </div>
      </section>
      {/* Our Values */}
      <section className="py-16 bg-white" data-id="element-585">
        <div className="container mx-auto px-4 md:px-8" data-id="element-586">
          <h2 className="text-3xl font-bold text-center text-navy-900 mb-12" data-id="element-587">
            Our Values
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-588">
            {values.map((value, index) => <div key={index} className="bg-navy-50 p-6 rounded-lg" data-id="element-589">
                <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-590">
                  {value.title}
                </h3>
                <p className="text-navy-700" data-id="element-591">{value.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-navy-800 text-white" data-id="element-592">
        <div className="container mx-auto px-4 md:px-8 text-center" data-id="element-593">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-594">
            Ready to Start Your Journey?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-595">
            Let us help you plan your next meaningful travel experience. Contact
            our team today.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-596">
            <a href="tel:+6567213357" className="bg-gold-500 hover:bg-gold-600 text-white px-8 py-3 rounded-md font-medium transition-colors" data-id="element-597">
              Call Us Now
            </a>
            <a href="mailto:info@kembarauztaz.com" className="bg-transparent border-2 border-white hover:bg-white hover:text-navy-900 text-white px-8 py-3 rounded-md font-medium transition-colors" data-id="element-598">
              Email Us
            </a>
          </div>
        </div>
      </section>
    </div>;
};
export default About;